/**
 * Created by Ning Jiang on 2017-10-12.
 */
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {DirtyWildsLayerConfig} from "../../config/DirtyWildsLayerConfig";
import {DirtyWilds} from "../DirtyWilds";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {DirtyWildReelView} from "./DirtyWildReelView";
import {EnvironmentTintContainer} from "../environment/parts/EnvironmentTintContainer";
import {DirtyWildGameModuleConfig} from "../DirtyWildGameModuleConfig";
import {TimelineLite, TweenLite} from "gsap";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameIntroController} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroController";


export class DirtyWildsRealAreaEvent {
    public static readonly INIT_SYM_BEHAVIOUR:string = "dirtyWildsRealAreaEvent_initSymBehaviour";
}

export class DirtyWildsReelAreaView extends ReelAreaView {
    private _maskSprite:PIXI.Sprite;
    private _middleLayer:PIXI.Container;
    private _topLayer:PIXI.Container;
    private _attentionLayer:PIXI.Container;
    private _noWinLayer:EnvironmentTintContainer;

    constructor() {
        super(ResourcesGroupName.MAIN);

        let mask = DirtyWildsReelAreaView.createMask();
        this.addChild(mask);
        this.mask = mask;

        this._noWinLayer = new EnvironmentTintContainer();
        mask = DirtyWildsReelAreaView.createMask();
        this._noWinLayer.addChild(mask);
        this._noWinLayer.mask = mask;

        this._middleLayer = new PIXI.Container();
        mask = DirtyWildsReelAreaView.createMask();
        this._middleLayer.addChild(mask);
        this._middleLayer.mask = mask;


        this._topLayer = new PIXI.Container();

        /*
                mask = DirtyWildsReelAreaView.createMask();
                this._topLayer.addChild(mask);
                this._topLayer.mask = mask;
        */

        this._attentionLayer = new PIXI.Container();


        StageManager.getLayer(DirtyWildsLayerConfig.SYMBOLS_NO_WIN.name).addChild(this._noWinLayer);
        StageManager.getLayer(DirtyWildsLayerConfig.SYMBOLS_MIDDLE.name).addChild(this._middleLayer);
        StageManager.getLayer(DirtyWildsLayerConfig.SYMBOLS_TOP.name).addChild(this._topLayer);
        StageManager.getLayer(DirtyWildsLayerConfig.SYMBOLS_ATTENTION.name).addChild(this._attentionLayer);
    }

    protected addEventListeners?(): void{
        EventHandler.addEventListener(this, DirtyWildsRealAreaEvent.INIT_SYM_BEHAVIOUR, (event: GameEvent) => this.toggleSymbolsVisibility(event.params[0]));
        EventHandler.addEventListener(this, GameIntroController.CLOSE, (event: GameEvent) => this.toggleSymbolsVisibility(true));
    }

    protected initAnimations():void {
        DirtyWildGameModuleConfig.environment.addNoWinContainer(this._noWinLayer);
    }

    private toggleSymbolsVisibility(animate:boolean):void{
        if(animate && this.alpha === 0){
            let symAnimateTl:TimelineLite = new TimelineLite();
            symAnimateTl.add([new TweenLite(this, 2, {alpha : 1}),
                new TweenLite(this._middleLayer, 2, {alpha : 1})], 1);
        }else if(!animate){
            this.alpha = 0;
            this._middleLayer.alpha = 0;
        }
    }

    protected onResize(resizeData:IResizeData):void {
        super.onResize(resizeData);

        this._noWinLayer.position.set(this.x, this.y);
        this._middleLayer.position.set(this.x, this.y);
        this._topLayer.position.set(this.x, this.y);
        this._attentionLayer.position.set(this.x, this.y);

    }

    protected updateReelViewPosition(reelView:PIXI.Container, reelId:number):void {
        const position = GameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        (<DirtyWildReelView>reelView).noWinLayer.position.set(position[0], position[1]);
        (<DirtyWildReelView>reelView).bottomLayer.position.set(position[0], position[1]);
        (<DirtyWildReelView>reelView).middleLayer.position.set(position[0], position[1]);
        (<DirtyWildReelView>reelView).topLayer.position.set(position[0], position[1]);
        (<DirtyWildReelView>reelView).attentionLayer.position.set(position[0], position[1]);

    }

    public addReelView(reel:ReelController):void {
        this._reelViews[reel.reelId] = <DirtyWildReelView>reel.view;
        this.updateReelViewPosition(reel.view, reel.reelId);

        this.addChild((<DirtyWildReelView>reel.view).bottomLayer);
        this._noWinLayer.addChild((<DirtyWildReelView>reel.view).noWinLayer);
        this._middleLayer.addChild((<DirtyWildReelView>reel.view).middleLayer);
        this._topLayer.addChild((<DirtyWildReelView>reel.view).topLayer);
        this._attentionLayer.addChild((<DirtyWildReelView>reel.view).attentionLayer);
    }

    public static createMaskGraphics():PIXI.Graphics {
        let gfx = new PIXI.Graphics();
        gfx.beginFill(0xFFFFFF, 0.5);
        gfx.drawRect(0, 0,
            GameConfig.instance.SYMBOL_WIDTH * 5,
            GameConfig.instance.SYMBOL_HEIGHT * 3);
        gfx.endFill();
        return gfx;
    }


    public static createMask(usePadding:boolean = false):PIXI.Graphics {
        let gradientHeight:number = 0;
        let paddingY:number = 0;
        let width = GameConfig.instance.SYMBOL_WIDTH * 7;
        let height = GameConfig.instance.SYMBOL_HEIGHT * 3 + gradientHeight -2;

        const reelMaskShape:PIXI.Graphics = new PIXI.Graphics();
        reelMaskShape.beginFill(0xFFFFF, 1);
        reelMaskShape.drawRect(-GameConfig.instance.SYMBOL_WIDTH, -(gradientHeight * 0.5 + paddingY * 0.5), width, height);
        reelMaskShape.endFill();

        return reelMaskShape;
    }
}